<div class="row a_center j_space" [ngClass]="{'active': isActive}">
    <div class="line"></div>
    <!-- <app-button-secondary [isGreen]="false" [isHover]="true" [isText]="true" [buttonText]="'Add new product'" [imgUrl]="'../../../assets/svg/plus-icon.svg'"></app-button-secondary> -->
    <button>
        <svg-icon src="../../../assets/svg/plus-icon.svg" *ngIf="additive"></svg-icon>
        <svg-icon src="../../../assets/svg/minus-icon.svg" *ngIf="!additive"></svg-icon>
        <span>{{buttonText}}</span>
    </button>
    <div class="line"></div>
</div>